import axios, { AxiosError } from 'axios';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import {ResponseError} from "../../../models";

export type ChangePasswordRequest = {
    email: string;
};

export function useChangePassword(
    options?: UseMutationOptions<unknown, AxiosError<ResponseError>, ChangePasswordRequest>
) {
    return useMutation({
        mutationFn: (request: ChangePasswordRequest) =>
            axios.post('/v1/change-password', request, {
                params: {
                    redirect: `${window.location.host}/login`
                }
            }),
        ...options
    });
}
